"use client";

import { Children } from "@/types/types";
import { Dispatch, SetStateAction, createContext, useState } from "react";

interface LanguageContextProps {
  language: "en" | "de";
}

const LanguageContextInit = {
  language: "en" as const,
};

interface LanguageProviderProps {
  children: Children;
  lang: string;
}

export const LanguageContext =
  createContext<LanguageContextProps>(LanguageContextInit);

function LanguageProvider({ children, lang }: LanguageProviderProps) {
  const [language, setLanguage] = useState<"en" | "de">(
    lang === "en" ? "en" : "de"
  );

  return (
    <LanguageContext.Provider
      value={{
        language,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageProvider;
